// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import AppRoot from './App'
import App from '@/components/application/Application'
import langs from '@/international/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhCnTranslationResource from '@/international/zh'
import enUsTranslationResource from '@/international/en'
import store from '@/store/store'
import * as types from '@/store/types'
import axios from '@/util/http'
import './assets/css/theme.scss'
import './assets/css/main.scss'
import 'animate.css'
import '../node_modules/font-awesome/css/font-awesome.css'

//require('./mock.js')

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.timeFormatter = function (row, col, val) {
  if(!val){
    return null;
  }
  return val;
}

// const i18n = new VueI18n({
//   locale: 'zh',  // 语言标识
//   messages: {
//     en: {
//       translation: enUsTranslationResource
//     },
//     zh: {
//       translation: zhCnTranslationResource
//     }
//   }
// })



// Vue.use(ElementUI, {
//   i18n: (key, value) => i18n._t(key, value)
// })
Vue.use(ElementUI);

Vue.use(VueI18n);


//const navLang = navigator.language // 检测系统语言
// const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false
//var localLang = 'zh-cn'
// if (navLang === 'zh-CN') {
//   localLang = 'zh-cn'
// } else {
//   localLang = 'en'
// }
//const _lang = window.localStorage.getItem('language') || localLang || 'zh-cn'
//Vue.config.lang = _lang

Vue.config.lang = 'zh-cn';

// 饿了吗语言包和项目自身语言包合并
const mergeZH = Object.assign(zhLocale, langs.chinese)
const mergeEN = Object.assign(enLocale, langs.english)
Vue.locale('zh-cn', mergeZH)
Vue.locale('en', mergeEN)
// 监控语言切换
// bus.$on('chang-langs', function (type) {
//   Vue.config.lang = type
//   window.localStorage.setItem('language', type)
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<AppRoot/>',
  components: { AppRoot }
})



// WEBPACK FOOTER //
// ./src/main.js